import React from 'react'
import PropTypes from 'prop-types'


const TaskResponsible = ({ taskReadOnly, userId, claimTask, unClaimTask, task, isTaskAdmin }) => {
    if (taskReadOnly) {
        return null
    }
    if (!task.assignedToUserId) {
        return (<i className="fa fa-lock lock-icon" onClick={claimTask}/>)
    }
    if (task.assignedToUserId === userId || !isTaskAdmin) {
        return (<i className="fa fa-unlock lock-icon" onClick={unClaimTask}/>)
    }
    return null
}

TaskResponsible.propTypes = {
    taskReadOnly: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
    task: PropTypes.object.isRequired,
    isTaskAdmin: PropTypes.bool.isRequired,
    claimTask: PropTypes.func.isRequired,
    unClaimTask: PropTypes.func.isRequired,
}


export default TaskResponsible



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TaskResponsible.js